module.exports = __webpack_public_path__ + "d41f55a7.ttf";